import { IonButton, IonContent, IonIcon, IonModal } from "@ionic/react";
import RobotImg from "../assets/graphics/robot-full.svg";
import { useHelpStore } from "../stores/help.store";
import { arrowForwardOutline } from "ionicons/icons";

function HelpModal() {
  const { isHelpOpen, activeData } = useHelpStore(state => state);
  const ionIcon = undefined;
  const setIsHelpOpen = useHelpStore(state => state.setIsHelpOpen);
  const onDismiss = () => {
    setIsHelpOpen(false);
  };

  return (
    <IonModal
      isOpen={isHelpOpen}
      onDidDismiss={onDismiss}
      initialBreakpoint={0.75}
      breakpoints={[0, 0.5, 0.75, 0.9]}
    >
      <IonContent className="ion-padding">
        <div className="flex items-center bg-primary-50 rounded-lg p-2 gap-2 w-fit mt-6">
          {ionIcon ? (
            <IonIcon icon={ionIcon} className="text-white text-base" />
          ) : (
            <img src={RobotImg} alt="Robot" className="max-h-4" />
          )}
          <p className="text-white">{activeData?.area}</p>
        </div>
        <h2 className="text-4xl my-6 text-white font-semibold">
          {activeData?.title}
        </h2>
        <p className="whitespace-pre-wrap mb-10">{activeData?.content}</p>
        <div className="text-center">
          <IonButton
            color="primary"
            className="text-sm"
            routerLink="/helpCenter"
          >
            Visit our Help Center
            <IonIcon slot="end" icon={arrowForwardOutline} />
          </IonButton>
        </div>
        <IonButton
          fill="clear"
          className="text-white h-16 text-base"
          expand="block"
          onClick={onDismiss}
        >
          Close
        </IonButton>
      </IonContent>
    </IonModal>
  );
}

export default HelpModal;
